import $ from "jquery";

$(document).ready(function() {
	$('main table').wrap('<div class="table-container" />');
});
